import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

@Pipe({
  name: 'countryPhone',
  standalone: true,
})
export class CountryPhonePipe implements PipeTransform {
  readonly phoneUtil = PhoneNumberUtil.getInstance();

  transform(value?: string): string {
    try {
      if (!value) throw 'No phone was provided.';

      const hasPrefix = value[0] === '+';
      const phone = this.phoneUtil.parse(hasPrefix ? value : '+' + value);

      return this.phoneUtil.format(phone, PhoneNumberFormat.INTERNATIONAL);
    } catch {
      return '';
    }
  }
}
